import { AnalyticsLayout as Page } from './AnalyticsLayout.main';
import { AnalyticsLayoutHeader as Header } from './AnalyticsLayoutHeader';

export const Analytics = { Header, Page };
